import React, { useContext } from "react";
import { Context } from "../../components/contexts/AppContext";

function TitleSubtitleUpdate() {
  const { value } = useContext(Context);
  const [appState] = value;

  /* ===================================
     Dynamic Responsive Font Size
  =================================== */

  // Desktop size from DB
  const desktopTitle =
    appState.currentTitleFontSize || 70;

  const desktopSubTitle =
    appState.currentSubTitleFontSize || 24;

  // Mobile auto smaller
  const mobileTitle = Math.max(
    desktopTitle * 0.55,
    26
  );

  const mobileSubTitle = Math.max(
    desktopSubTitle * 0.65,
    14
  );

  return (
    <div className="text-left text-white">

    {/* TITLE */}
<div
  style={{
    fontFamily: appState.currentFontFamilyVideoTitle,
    color: appState.currentTitleColor,
    fontSize: `clamp(${mobileTitle}px, 7vw, ${desktopTitle}px)`,
    lineHeight: "1.05",
    marginBottom: "2px",
  }}
>
  {appState.currentGalleryVideoTitle}
</div>

{/* SUBTITLE */}
<div
  style={{
    fontFamily: appState.currentFontFamilyVideoSubTitle,
    color: appState.currentSubTitleColor,
    fontSize: `clamp(${mobileSubTitle}px, 3vw, ${desktopSubTitle}px)`,
    lineHeight: "1.1",
  }}
  className="mt-0"
>
  {appState.currentGalleryVideoSubTitle}
</div>

    </div>
  );
}

export default TitleSubtitleUpdate;